import { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

/**
 * Silent, gentle logout overlay. Replaces the "Signed out" toast.
 * White centered card with logo + "See you soon" fades out over 800ms.
 * Parent triggers redirect after the same duration.
 *
 * Usage:
 *   <SignOutOverlay show={loggingOut} />
 */
export default function SignOutOverlay({ show }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!show) {
      setFadeOut(false);
      return;
    }
    // Start fade-out ~150ms before parent redirects so it lands smoothly
    const t = setTimeout(() => setFadeOut(true), 650);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="signout-overlay"
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-white/70 backdrop-blur-sm transition-opacity duration-300 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <div
        className={`flex flex-col items-center gap-3 rounded-2xl bg-white px-8 py-6 shadow-lg transition-all duration-500 ${
          fadeOut ? "scale-95 opacity-0" : "scale-100 opacity-100"
        }`}
      >
        <Logo />
        <p className="text-sm text-neutral-500">See you soon</p>
      </div>
    </div>
  );
}
